import {Component,OnInit} from '@angular/core';
import {ActivatedRoute,ParamMap} from '@angular/router';

import {Principal} from 'src/app/core';
import {IPackingTypeMySuffix} from 'src/app/shared/model/packing-type-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {RoleUtil} from 'src/app/shared/util/role-util';

@Component({
    selector: 'jhi-packing-type-my-suffix-detail',
    templateUrl: './packing-type-my-suffix-detail.component.html'
})
export class PackingTypeMySuffixDetailComponent implements OnInit {
    packingType: IPackingTypeMySuffix;
    isShowPastHistory: any;
    isShowFutureHistory: any;

    public readonly RoleUtil=RoleUtil;

    constructor(private principal: Principal,
        private activatedRoute: ActivatedRoute,
        private languageChangeService: LanguageChangeService) {
            
                this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
    }

    ngOnInit() {
        this.isShowPastHistory = this.principal.isShowPastHistory;
        this.isShowFutureHistory = this.principal.isShowFutureHistory;
        this.activatedRoute.data.subscribe(({ packingType }) => {
            this.packingType = packingType;
        });
    }

    previousState() {
        window.history.back();
    }

    // history
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;
    
    parentHistoryToggle = false;
    parentFutureHistoryToggle = false;
    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
        this.parentFutureHistoryToggle = $event;
    }

    viewFutureHistory(Obj) { //Future Records
        this.parentFutureHistoryToggle = true;
        this.historyTitle = 'Packing Type (' + Obj.name + ') Future Records';
        this.historyType = "PACKING_TYPE_AUDIT";
        this.historyId = Obj.id;

    }

    viewHistory(Obj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Packing Type (' + Obj.name + ') History';
        this.historyType = "PACKING_TYPE_AUDIT";
        this.historyId = Obj.id;
    }
    hideFutureHistorySidebar() {
        if (document.getElementById("future-history-window")) {
            this.parentHistoryToggle = false;
            this.parentFutureHistoryToggle = false;
        }
    }
}
